<template>
    <div class="dd-m-menu__header" v-if="!signed">
        <!--button v-on:click="openLoginModal()" type="button" class="dd-m-helper--inherit">
            <i class="dd-m-icon icon-user"></i>
            <span>Hello! Login or create an account</span>
        </button-->
    </div>
</template>
<script>
    export default {
        name: 'auth-do-sign',
        data: () => {
            return {
                signed: false
            }
        },
        mounted() {
            this.checkSign();
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('updatedSign', () => this.checkSign());
            },
            checkSign() {
                this.signed = this.isSignedIn();
            },
            isSignedIn() {
                return localStorage.token;
            },
            openLoginModal: () => {
                PubSub.publish('openLoginModal');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-do-sign.vue